import type { PostProcessorsRootMap } from './shared/post-processors';
import type { CorePostProcessorKey } from './shared/types';

/*
 * Пусто намеренно.
 *
 * Здесь чинились падежи и хвосты, которые приносил Intl.RelativeTimeFormat
 * в pluralizeTimeUnit: 'неделю' → 'неделя' (ru, kk), 'недељу' → 'недеља' (sr),
 * отрезание '後' (ja), 'خلال' (ar), '后' (zh).
 *
 * pluralizeTimeUnit построен на Intl.NumberFormat({ style: 'unit' }) и отдаёт
 * словарную форму сам — по всем локалям, включая те, которых нет в этом списке.
 * См. adr/0002-pluralize-time-unit-on-number-format.md.
 *
 * Точка расширения оставлена: сюда добавляются пост-обработки собственных
 * методов класса (CorePostProcessorKey), если они понадобятся.
 */
const corePostProcessors: PostProcessorsRootMap<CorePostProcessorKey, null> = {};


export {
    corePostProcessors,
}
